import { STATUS_CODE } from '~/constants'
import request from './request'

// LIST RECOMMEND MENU
export const getListRecommendMenuApi = async (storeId) => {
  const URL = `restaurants/${storeId}/recommend_items`
  const params = {}
  params.limit = 1000

  try {
    const { data, status } = await request().get(URL, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.data || [],
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: [],
    }
  }
}
